// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Eth from "./Eth.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Ethers from "ethers";
import * as $$Promise from "reason-promise/src/js/promise.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as UserProvider from "./js/user-provider/UserProvider.bs.js";
import * as ThemeProvider from "./bindings/rimble/ThemeProvider.bs.js";
import * as Web3Connectors from "./bindings/web3-react/Web3Connectors.bs.js";
import * as Core from "@web3-react/core";
import * as ReasonReactRouter from "reason-react/src/ReasonReactRouter.bs.js";

var Web3ReactProvider = {};

function getLibrary(provider) {
  var library = new (Ethers.providers.Web3Provider)(provider);
  var setPollingInterval = (lib => {lib.pollingInterval = 8000; return lib; });
  return setPollingInterval(library);
}

var initialState = {
  nonUrlState: /* NoExtraState */2,
  ethState: /* Disconnected */0,
  config: {
    stewardContractAddress: undefined,
    stewardAbi: undefined
  }
};

function reducer(_prevState, _action) {
  while(true) {
    var action = _action;
    var prevState = _prevState;
    if (typeof action === "number") {
      switch (action) {
        case /* GoToDepositUpdate */1 :
            var match = prevState.ethState;
            if (match) {
              return {
                      nonUrlState: /* UpdateDepositScreen */1,
                      ethState: prevState.ethState,
                      config: prevState.config
                    };
            } else {
              return {
                      nonUrlState: {
                        TAG: /* LoginScreen */0,
                        _0: action
                      },
                      ethState: prevState.ethState,
                      config: prevState.config
                    };
            }
        case /* GoToUserVerification */2 :
            var match$1 = prevState.ethState;
            if (match$1) {
              return {
                      nonUrlState: /* UserVerificationScreen */0,
                      ethState: prevState.ethState,
                      config: prevState.config
                    };
            } else {
              return {
                      nonUrlState: {
                        TAG: /* LoginScreen */0,
                        _0: action
                      },
                      ethState: prevState.ethState,
                      config: prevState.config
                    };
            }
        case /* NoAction */0 :
        case /* ClearNonUrlState */3 :
            return {
                    nonUrlState: /* NoExtraState */2,
                    ethState: prevState.ethState,
                    config: prevState.config
                  };
        case /* Logout */4 :
            return {
                    nonUrlState: /* NoExtraState */2,
                    ethState: /* Disconnected */0,
                    config: prevState.config
                  };
        
      }
    } else {
      switch (action.TAG | 0) {
        case /* GoToBuy */0 :
            var match$2 = prevState.ethState;
            if (match$2) {
              return {
                      nonUrlState: {
                        TAG: /* BuyScreen */2,
                        _0: action._0
                      },
                      ethState: prevState.ethState,
                      config: prevState.config
                    };
            } else {
              return {
                      nonUrlState: {
                        TAG: /* LoginScreen */0,
                        _0: action
                      },
                      ethState: prevState.ethState,
                      config: prevState.config
                    };
            }
        case /* GoToAuction */1 :
            var match$3 = prevState.ethState;
            if (match$3) {
              return {
                      nonUrlState: {
                        TAG: /* AuctionScreen */3,
                        _0: action._0
                      },
                      ethState: prevState.ethState,
                      config: prevState.config
                    };
            } else {
              return {
                      nonUrlState: {
                        TAG: /* LoginScreen */0,
                        _0: action
                      },
                      ethState: prevState.ethState,
                      config: prevState.config
                    };
            }
        case /* GoToPriceUpdate */2 :
            var match$4 = prevState.ethState;
            if (match$4) {
              return {
                      nonUrlState: {
                        TAG: /* UpdatePriceScreen */1,
                        _0: action._0
                      },
                      ethState: prevState.ethState,
                      config: prevState.config
                    };
            } else {
              return {
                      nonUrlState: {
                        TAG: /* LoginScreen */0,
                        _0: action
                      },
                      ethState: prevState.ethState,
                      config: prevState.config
                    };
            }
        case /* GoToWeb3Connect */3 :
            var action$1 = action._0;
            var match$5 = prevState.ethState;
            if (!match$5) {
              return {
                      nonUrlState: {
                        TAG: /* LoginScreen */0,
                        _0: action$1
                      },
                      ethState: prevState.ethState,
                      config: prevState.config
                    };
            }
            _action = action$1;
            continue ;
        case /* LoadAddress */4 :
            var newState_nonUrlState = prevState.nonUrlState;
            var newState_ethState = /* Connected */{
              _0: action._0,
              _1: action._1
            };
            var newState_config = prevState.config;
            var newState = {
              nonUrlState: newState_nonUrlState,
              ethState: newState_ethState,
              config: newState_config
            };
            var followOnAction = prevState.nonUrlState;
            if (typeof followOnAction === "number") {
              return newState;
            }
            if (followOnAction.TAG !== /* LoginScreen */0) {
              return newState;
            }
            _action = followOnAction._0;
            _prevState = newState;
            continue ;
        
      }
    }
  };
}

var context = React.createContext([
      initialState,
      (function (param) {
          
        })
    ]);

var make = context.Provider;

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

var RootContext = {
  context: context,
  make: make,
  makeProps: makeProps
};

function RootProvider$RootWithWeb3(Props) {
  var children = Props.children;
  var stewardContractAddress = Props.stewardContractAddress;
  var stewardAbi = Props.stewardAbi;
  var match = React.useReducer(reducer, {
        nonUrlState: /* NoExtraState */2,
        ethState: /* Disconnected */0,
        config: {
          stewardContractAddress: stewardContractAddress,
          stewardAbi: stewardAbi
        }
      });
  var dispatch = match[1];
  var context = Core.useWeb3React();
  var match$1 = React.useState(function () {
        return false;
      });
  var setTriedLoginAlready = match$1[1];
  var triedLoginAlready = match$1[0];
  React.useEffect((function () {
          $$Promise.get(Curry._1(Web3Connectors.injected.isAuthorized, undefined), (function (authorised) {
                  if (authorised && !triedLoginAlready) {
                    $$Promise.Js.$$catch(Curry._3(context.activate, Web3Connectors.injected, (function (param) {
                                
                              }), true), (function (param) {
                            Curry._1(setTriedLoginAlready, (function (param) {
                                    return true;
                                  }));
                            return $$Promise.resolved(undefined);
                          }));
                    return ;
                  } else {
                    return Curry._1(setTriedLoginAlready, (function (param) {
                                  return true;
                                }));
                  }
                }));
          var match = context.chainId;
          if (match !== undefined) {
            
          } else {
            Curry._1(dispatch, /* Logout */4);
          }
          
        }), [
        context.activate,
        context.chainId,
        dispatch,
        setTriedLoginAlready,
        triedLoginAlready
      ]);
  React.useEffect((function () {
          if (!triedLoginAlready && context.active) {
            Curry._1(setTriedLoginAlready, (function (param) {
                    return true;
                  }));
          }
          
        }), [
        triedLoginAlready,
        context.active,
        setTriedLoginAlready
      ]);
  React.useEffect((function () {
          var match = context.library;
          var match$1 = context.account;
          if (match !== undefined && match$1 !== undefined) {
            $$Promise.get($$Promise.Js.$$catch(match.getBalance(match$1), (function (param) {
                        return $$Promise.resolved(undefined);
                      })), (function (newBalance) {
                    return Curry._1(dispatch, {
                                TAG: /* LoadAddress */4,
                                _0: match$1,
                                _1: Belt_Option.flatMap(newBalance, (function (balance) {
                                        return Eth.make(balance.toString());
                                      }))
                              });
                  }));
            return ;
          }
          
        }), [
        context.library,
        context.account,
        context.chainId,
        dispatch
      ]);
  return React.createElement(make, makeProps([
                  match[0],
                  dispatch
                ], children, undefined));
}

var RootWithWeb3 = {
  make: RootProvider$RootWithWeb3
};

function useRootContext(param) {
  return React.useContext(context)[0];
}

function useStewardContractAddress(param) {
  var match = React.useContext(context);
  return match[0].config.stewardContractAddress;
}

function useStewardAbi(param) {
  var match = React.useContext(context);
  return match[0].config.stewardAbi;
}

function useCurrentUser(param) {
  var match = React.useContext(context);
  var match$1 = match[0].ethState;
  if (match$1) {
    return match$1._0;
  }
  
}

function useIsAddressCurrentUser(address) {
  var currentUser = useCurrentUser(undefined);
  if (currentUser !== undefined) {
    return address.toLowerCase() === currentUser.toLowerCase();
  } else {
    return false;
  }
}

function useIsProviderSelected(param) {
  var match = React.useContext(context);
  var match$1 = match[0].ethState;
  if (match$1) {
    return true;
  } else {
    return false;
  }
}

function useEthBalance(param) {
  var match = React.useContext(context);
  var match$1 = match[0].ethState;
  if (match$1) {
    return match$1._1;
  }
  
}

function useNonUrlState(param) {
  var match = React.useContext(context);
  return match[0].nonUrlState;
}

function useShowLogin(param) {
  var nonUrlRouting = useNonUrlState(undefined);
  if (typeof nonUrlRouting === "number" || nonUrlRouting.TAG !== /* LoginScreen */0) {
    return false;
  } else {
    return true;
  }
}

function useNetworkId(param) {
  return Core.useWeb3React().chainId;
}

function useEtherscanUrl(param) {
  var networkId = Core.useWeb3React().chainId;
  if (networkId !== undefined) {
    if (networkId !== 4) {
      if (networkId !== 5) {
        return "etherscan.io";
      } else {
        return "goerli.etherscan.io";
      }
    } else {
      return "rinkeby.etherscan.io";
    }
  } else {
    return "etherscan.io";
  }
}

function useSidechainEtherscanUrl(param) {
  var networkId = Core.useWeb3React().chainId;
  if (networkId !== undefined) {
    if (networkId !== 4) {
      if (networkId !== 5) {
        return "explorer.matic.network";
      } else {
        return "mumbai-explorer.matic.today";
      }
    } else {
      return "goerli.etherscan.io";
    }
  } else {
    return "explorer.matic.network";
  }
}

function useDeactivateWeb3(param) {
  return Core.useWeb3React().deactivate;
}

function useWeb3(param) {
  return Core.useWeb3React().library;
}

function useGoToBuy(param) {
  var match = React.useContext(context);
  var dispatch = match[1];
  return function (animal) {
    return Curry._1(dispatch, {
                TAG: /* GoToBuy */0,
                _0: animal
              });
  };
}

function useGoToAuction(param) {
  var match = React.useContext(context);
  var dispatch = match[1];
  return function (animal) {
    return Curry._1(dispatch, {
                TAG: /* GoToAuction */1,
                _0: animal
              });
  };
}

function useGoToDepositUpdate(param) {
  var match = React.useContext(context);
  var dispatch = match[1];
  return function (param) {
    return Curry._1(dispatch, /* GoToDepositUpdate */1);
  };
}

function useGoToPriceUpdate(param) {
  var match = React.useContext(context);
  var dispatch = match[1];
  return function (animal) {
    return Curry._1(dispatch, {
                TAG: /* GoToPriceUpdate */2,
                _0: animal
              });
  };
}

function useVerifyUser(param) {
  var match = React.useContext(context);
  var dispatch = match[1];
  return function (param) {
    return Curry._1(dispatch, /* GoToUserVerification */2);
  };
}

function useClearNonUrlState(param) {
  var match = React.useContext(context);
  var dispatch = match[1];
  return function (param) {
    return Curry._1(dispatch, /* ClearNonUrlState */3);
  };
}

function useConnectWeb3(param) {
  var match = React.useContext(context);
  var dispatch = match[1];
  return function (action) {
    return Curry._1(dispatch, {
                TAG: /* GoToWeb3Connect */3,
                _0: action
              });
  };
}

function useCloseWeb3Login(param) {
  var match = React.useContext(context);
  var dispatch = match[1];
  return function (param) {
    return Curry._1(dispatch, /* ClearNonUrlState */3);
  };
}

function useClearNonUrlStateAndPushRoute(param) {
  var clearNonUrlState = useClearNonUrlState(undefined);
  return function (url) {
    Curry._1(clearNonUrlState, undefined);
    return ReasonReactRouter.push(url);
  };
}

function useActivateConnector(param) {
  var context = Core.useWeb3React();
  var match = React.useState(function () {
        return /* Standby */0;
      });
  var setConnectionStatus = match[1];
  return [
          match[0],
          (function (provider) {
              $$Promise.get($$Promise.Js.$$catch(Curry._3(context.activate, provider, (function (param) {
                              
                            }), true), (function (error) {
                          console.log("Error connecting to network:");
                          console.log(error);
                          Curry._1(setConnectionStatus, (function (param) {
                                  return /* ErrorConnecting */3;
                                }));
                          return $$Promise.resolved(undefined);
                        })), (function (param) {
                      return Curry._1(setConnectionStatus, (function (param) {
                                    return /* Connected */1;
                                  }));
                    }));
              return Curry._1(setConnectionStatus, (function (param) {
                            return /* Connecting */2;
                          }));
            })
        ];
}

function RootProvider(Props) {
  var children = Props.children;
  var stewardContractAddress = Props.stewardContractAddress;
  var stewardAbi = Props.stewardAbi;
  return React.createElement(Core.Web3ReactProvider, {
              getLibrary: getLibrary,
              children: React.createElement(RootProvider$RootWithWeb3, {
                    children: React.createElement(UserProvider.make, {
                          children: React.createElement(ThemeProvider.make, {
                                children: children
                              })
                        }),
                    stewardContractAddress: stewardContractAddress,
                    stewardAbi: stewardAbi
                  })
            });
}

var make$1 = RootProvider;

export {
  Web3ReactProvider ,
  getLibrary ,
  initialState ,
  reducer ,
  RootContext ,
  RootWithWeb3 ,
  useRootContext ,
  useStewardContractAddress ,
  useStewardAbi ,
  useCurrentUser ,
  useIsAddressCurrentUser ,
  useIsProviderSelected ,
  useEthBalance ,
  useNonUrlState ,
  useShowLogin ,
  useNetworkId ,
  useEtherscanUrl ,
  useSidechainEtherscanUrl ,
  useDeactivateWeb3 ,
  useWeb3 ,
  useGoToBuy ,
  useGoToAuction ,
  useGoToDepositUpdate ,
  useGoToPriceUpdate ,
  useVerifyUser ,
  useClearNonUrlState ,
  useConnectWeb3 ,
  useCloseWeb3Login ,
  useClearNonUrlStateAndPushRoute ,
  useActivateConnector ,
  make$1 as make,
  
}
/* context Not a pure module */
